export default class LanguageWriteDTO {

    public id: string | undefined;
    public name: string | undefined;
    public localeKey: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.localeKey = data['localeKey'] || undefined;
    }
}